import * as yup from 'yup'

export const residentSchema = yup.object().shape({
  email: yup.string().email().required('Email is required'),
  dateOfOccupancy: yup.date().required('Date of occupancy is required'),
  address: yup.string().required('Address is required'),
  isOwner: yup.boolean().when('isResident', {
    is: false,
    then: (schema) =>
      schema.oneOf([true], 'At least one of Owner or Resident must be selected'),
    otherwise: (schema) => schema.notRequired(),
  }),
  isResident: yup.boolean(),
  landlord: yup.string().when(['isResident', 'isOwner'], {
    is: (isResident: boolean, isOwner: boolean) => isResident && !isOwner,
    then: (schema) => schema.required('Landlord is required'),
    otherwise: (schema) => schema.notRequired(),
  }),
  property: yup.string().when(['isResident', 'isOwner'], {
    is: (isResident: boolean, isOwner: boolean) => isResident && !isOwner,
    then: (schema) => schema.required('Property is required'),
    otherwise: (schema) => schema.notRequired(),
  }),
  capacity: yup.number().when('isOwner', {
    is: true,
    then: (schema) =>
      schema.min(1, 'Capacity must be at least 1').required('Capacity is required'),
    otherwise: (schema) => schema.notRequired(),
  }),
    residentType: yup.string().when('isResident', {
     is: true,
     then: (schema) => schema.required('Resident Type is required'),
     otherwise: (schema) => schema.strip(),
   })
})
